import { Participant, ParticipantType } from '@cds/betting-offer';
import { EventParticipant, EventParticipantType } from '@frontend/sports/betting-offer/feature/model';

export const getEventParticipants = (input: { participants?: Participant[] }): EventParticipant[] => {
    return (
        input.participants
            ?.filter((pa) => pa.properties?.type && [ParticipantType.HomeTeam, ParticipantType.AwayTeam].includes(pa.properties.type))
            .map<EventParticipant>((t) => {
                const x: EventParticipant = {
                    name: t.name.value,
                    shortName: t.name.short,
                    id: t.id,
                    fixtureParticipantId: t.participantId,
                    image: t.image,
                    type: t.properties?.type === ParticipantType.HomeTeam ? EventParticipantType.Home : EventParticipantType.Away,
                    teamId: t.properties?.team,
                };

                return x;
            }) ?? []
    );
};
